/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-25 10:33:05
 * @LastEditors: sj
 * @LastEditTime: 2022-01-25 17:42:46
 */
export function getDentureLedgerStatus(i: number): string {
  switch (i) {
    case 0:
      return '未完工'
    case 1:
      return '已完工'
    case 2:
      return '已取件'
    case 3:
      return '试戴'
    case 4:
      return '已戴走'
    case 5:
      return '返工'
    default:
      return '-'
  }
}
